import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyProfileService } from '../property-profile.service';
import { PropertyProfile } from '../property-profile';
import { PropertyService } from '@app/_components/property';
import { OwnerProfileService } from '@app/_components/owner-profile/owner-profile.service';
import { OwnerProfileComponent } from '@app/_components/owner-profile/owner-profile/owner-profile.component';
import { OwnerProfile } from '@app/_components/owner-profile/owner-profile';
import { PercentageValuesPositive } from '@app/_helpers';
import { PropertyLeadProfileService } from '@app/_components/property-lead-profile/property-lead-profile.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { ActivatedRoute } from '@angular/router';
import { TravelAgentProfileService } from '@app/_components/travel-agent-profile/travel-agent-profile.service';
import Utils from "@app/_components/_shared/utils"
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';

@Component({
    selector: 'app-property-profile',
    templateUrl: './property-profile.component.html',
    styleUrls: ['./property-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyProfileComponent implements OnInit {
   // realEstateStatus: any;
    properties: any;
	ownerProfilesList: any[]=[];
	userData : any;
	assignedToUserId;
	realEstateStatus : { name: string; value: string; }[];
	isDisplayOwnerProfile : boolean = true;
	propertyProfile: PropertyProfile;
	ownerProfileObj : OwnerProfile[] =[];
	countries: any;
	states: any;
	trnsReasons: any;
	percentageValuesPositive: any = PercentageValuesPositive;
	filteredNames: any[] = [];
	propertyLeadProfile: any;
	percentages: any;
	taxPaidOptions: any;
	revenuePlanOptions: { name: string; value: number; }[] = [
		{ name: 'RevMax', value: 1 },
		{ name: 'Occupancy Moderation', value: 2 }
	];
	propertyConditionOptions: { name: string; value: number; }[] = [
		{ name: 'Dump', value: 1 },
		{ name: 'Poor', value: 2 },
		{ name: 'Below Average', value: 3 },
		{ name: 'Fair', value: 4 },
		{ name: 'Average', value: 5 },
		{ name: 'Above Average', value: 6 },
		{ name: 'Good', value: 7 },
		{ name: 'Very Good', value: 8 },
		{ name: 'Excellent', value: 9 },
		{ name: 'Pristine', value: 10 }
	];
	
	notesChatConfig: NotesChatConfig = {
		title: 'Property Profile Notes',
		maxWidth: '100%',
		maxHeight: '250px',
		customClass: '',
		fieldsPosition: 'top',
		showFilters: true,
		showSortOptions: false,
		fillParent: false,
		sortByDate: 'desc',
		allowEdit: true,
		allowDelete: false,
		allowAdd: true,
		emptyNotesText: 'No notes added',
		placeholder: 'Enter remarks',
		theme: 'default',
		maxNoteLength: 150,
		editButtonText: 'Edit Note',
		deleteButtonText: 'Delete Note',
		cancelButtonText: 'Cancel',
		noteTypes: [
			{ value: 1, name: 'General', color: '#DCDCDC' },
			{ value: 2, name: 'Action Item', color: '#ffcccc' },
			{ value: 4, name: 'Meeting Notes', color: '#ade061' },
			{ value: 5, name: 'Status Update', color: '#FFFF99' }
		],
		statusOptions: [
			{ value: 0, name: 'Open', color: '#D3D3D3' },
			{ value: 1, name: 'Complete', color: '#90EE90' },
			{ value: 2, name: 'Proposed', color: '#FFE599' },
			{ value: 3, name: 'On Hold', color: '#ADD8E6' },
			{ value: 4, name: 'Cancelled', color: '#F4A6A6' },
			{ value: 5, name: 'In Progress', color: '#FFA500' }
		]
	};
	maintServiceFreqOptions: any[]=[];

	constructor(
		private constantService: ConstantService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private propertyProfileService: PropertyProfileService,
		private propertyLeadProfileService: PropertyLeadProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private activatedRoute: ActivatedRoute,
		private dialog: MatDialog,
		private ownerProfileService: OwnerProfileService,
		private travelAgentProfileService: TravelAgentProfileService,
		private cdr: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.isDisplayOwnerProfile = data.isDisplayOwnerProfile == false ? false : true,
			this.propertyProfile = data.propertyProfile,
			this.realEstateStatus = propertyProfileService.realEstateStatuses;
			this.countries = this.constantService.countries;
			this.states = this.constantService.states;
		this.trnsReasons = propertyProfileService.trnsReasons;

		this.percentages = travelAgentProfileService.percentages;
		this.taxPaidOptions = propertyProfileService.taxPaidOptions;
		this.maintServiceFreqOptions = propertyProfileService.maintServiceFreqOptions;
	}

	//@Input() propertyProfile: PropertyProfile;

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doUpdateShowResIncomeFlag = new EventEmitter<any>();

	// data
	propertyProfileId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	propertyProfileObj !: PropertyProfile;




	validationMessages = {
		'propertyProfileId': [],
		'propertyName': [{ type: 'required', message: 'Required' }],
		'realEstateStatus': [{ type: 'required', message: 'Required' }],
		'shortTermRentalId': [],
		'propertyCode': [],
		'numFreeHousekeepings': [],
		'numFreeRentalCarNights': [],
		'fedTaxName': [],
		'fedTaxBusName': [],
		'fedTaxClass': [],
		'fedTaxId': [],
		'fedTaxAddress': [],
		'taxPreparationSource': [],
		'newReservationAlertEmail': [],
		'newReservationAlertText': [],
		'insCompanyName': [],
		'insPolicyNum': [],
		'insAgentName': [],
		'insAgentEmail': [],
		'insAgentPhone': [],
		'bankName': [],
		'bankRoutingNum': [],
		'bankAccountNum': [],
		'ambassadorUserId': [],
		'taxDeptUsername': [],
		'taxDeptPassword': [],
		'taxDeptNotes': [],
		'deepCleanPrepDays': [],
		'ownerProfileVOList':  [],
		subjAdrCompanyName: [],
		subjAdrStreet: [],
		subjAdrStreet2: [],
		subjAdrCity: [],
		subjAdrState: [],
		subjAdrPostalCode: [],
		subjAdrCountry: [],
		subjAdrPhone: [],
		subjAdrFax: [],
		subjAdrUnit: [],
		subjAdrDevelopmentName: [],
		subjAdrDistrictName: [],
		subjAdrCounty: [],
		subjAdrRegion: [],
		subjAdrIsland: [],
		subjAdrCrossStreet: [],
		subjAdrLongitude: [],
		subjAdrLatitude: [],
		opsNotes: [],
		contractSignDate: [],
		firstCheckInDate: [],
		mgmtCommPct: [],
		subjAdrBuildingName: [],
		subjAdrComplexName: [],
		subjAdrStreetNumber: [],
		photographerDesc: [],
		trnsInEffectiveDate: [],
		trnsInReason: [],
		trnsInReasonDesc: [],
		trnsInNewMgrName: [],
		trnsInProcessDesc: [],
		trnsInHonoredBookingsDesc: [],
		trnsOutNoticeDate: [],
		trnsOutEffectiveDate: [],
		trnsOutReason: [],
		trnsOutReasonDesc: [],
		trnsOutNewMgrName: [],
		trnsOutProcessDesc: [],
		trnsOutHonoredBookingsDesc: [],
		taxPaidBy:[],
		showRezIncome: [],
		gig: [],
		purchasePriceAMT: [],
		purchaseDate: [],
		viewOnlineStmt:[],
		showPastReservationIncome:[],
		showPastOccupancyCalander:[],
		showMaintenanceTab:[],
		propertyLeadProfileId: [],


		estGrossRev: [],
		initialTermLengthMonths: [],
		subsequentTermLengthMonths: [],
		mgmtFeePCT: [],
		freeDepartureCleanNUM: [],
		freeCarDaysNUM: [],
		signCreditAMT: [],
		remodelCreditAMT: [],
		upgradeCredit: [],
		mgmtFeeCreditAMT: [],
		otherCreditAMT: [],
		termsSummaryDesc: [],
		maxMaintenanceFeeDiscretionAMT: [],
		referralFeeAMT: [],
		revenuePlan: [],
		propertyCondition: [],
		propertyScore: [],
		propertyScoreDesc: [],
		stmtProcDesc: [],
		bookingFee: [],
		maintServiceFreq: []
	};

	async ngOnInit() {
		// Used to fetchOwnerProfile Data
		this.fetchOwnerProfiles();
		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();


		// if we were passed the whole propertyProfile object
		if (this.propertyProfile) {
			//set custom option label
			this.propertyProfile.ownerProfileVOList.forEach((ownerProfile, i) => {
				//set custom option label
				this.propertyProfile.ownerProfileVOList[i] = this.setPropertyLeadDisplayLabel(ownerProfile);
			});
			this.propertyProfileId = this.propertyProfile.propertyProfileId;
			if(this.propertyProfile.showRezIncome != "true"){
				this.propertyProfile.showRezIncome = false;
			}else{
				this.propertyProfile.showRezIncome = true;
			}
			if(this.propertyProfile.trnsOutNoticeDate != undefined && this.propertyProfile.trnsOutNoticeDate != null){
				this.propertyProfile.trnsOutNoticeDate = moment.utc(this.propertyProfile.trnsOutNoticeDate).toDate();
			}
			if(this.propertyProfile.contractSignDate != undefined && this.propertyProfile.contractSignDate != null){
				this.propertyProfile.contractSignDate = moment.utc(this.propertyProfile.contractSignDate).toDate();
			}
			if(this.propertyProfile.firstCheckInDate != undefined && this.propertyProfile.firstCheckInDate != null){
				this.propertyProfile.firstCheckInDate = moment.utc(this.propertyProfile.firstCheckInDate).toDate();
			}
			if(this.propertyProfile.purchaseDate != undefined && this.propertyProfile.purchaseDate != null){
				this.propertyProfile.purchaseDate = moment.utc(this.propertyProfile.purchaseDate).toDate();
			}
			this.fixDates();
			if (this.propertyProfile.propertyLeadProfileId) {
				try{
				//making this synchronous so that locationId is not populated with null value
				const res = await firstValueFrom(
					this.propertyLeadProfileService.findById(this.propertyProfile.propertyLeadProfileId)
				);

				const locationObj = {
					propertyLeadProfileId: res.data.propertyLeadProfile?.propertyLeadProfileId,
					firstName: res.data.propertyLeadProfile?.firstName,
					lastName: res.data.propertyLeadProfile?.lastName,
					subjAdrDevelopmentName: res.data.propertyLeadProfile?.subjAdrDevelopmentName,
					subjAdrStreet: res.data.propertyLeadProfile?.subjAdrStreet,
					summary: res.data.propertyLeadProfile?.subjAdrStreet+" "+res.data.propertyLeadProfile?.subjAdrDevelopmentName+" "+res.data.propertyLeadProfile?.firstName+" "+res.data.propertyLeadProfile?.lastName+" "+res.data.propertyLeadProfile?.propertyLeadProfileId
				};

				this.filteredNames = [locationObj];
				this.propertyProfile.propertyLeadProfileId = locationObj;

				this.form1.patchValue({
					propertyLeadProfileId: locationObj
				});
				this.formLoading = false;

				} catch (error) {
					console.log(error);
				}
			}
			this.form1.patchValue(this.propertyProfile);

      if(this.propertyProfile.trnsInEffectiveDate != undefined && this.propertyProfile.trnsInEffectiveDate != null){
        this.form1.patchValue({
          trnsInEffectiveDate : Utils.parseDateOnly(this.propertyProfile.trnsInEffectiveDate.toString())
        });
      }
      if(this.propertyProfile.trnsOutEffectiveDate != undefined && this.propertyProfile.trnsOutEffectiveDate != null){
        this.form1.patchValue({
          trnsOutEffectiveDate : Utils.parseDateOnly(this.propertyProfile.trnsOutEffectiveDate.toString())
        });
      }


		}else{
			this.activatedRoute.params.subscribe(params => {
				this.propertyProfileId = params.propertyProfileId; // (+) converts string 'id' to a number
			});
			if (this.propertyProfileId != null && this.propertyProfileId != undefined) {
				this.findPropertyProfileById();
			}
		}
	}

	setAssignedToUserId($event)
	{
		console.log($event);
		this.assignedToUserId = $event['assignedToUserId'];
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.propertyProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	onFormDeleteOfOwnerProfile(ownerProfile: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + ownerProfile?.ownerProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDeleteOfOwnerProfile(ownerProfile);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			
			// Create a copy of form values and convert dates to UTC midnight
			const formData = { ...this.form1.value };
			if(formData?.propertyLeadProfileId?.propertyLeadProfileId != undefined && formData?.propertyLeadProfileId?.propertyLeadProfileId != null){
				formData.propertyLeadProfileId = formData?.propertyLeadProfileId?.propertyLeadProfileId;
			}
			this.convertDatesToUtcMidnight(formData);

			this.propertyProfileService.add(formData)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyProfile = res.data.propertyProfile;
						this.doAdd.emit(this.propertyProfile);
					},
					(err: any) => {
						console.log('propertyProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('propertyProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			
			// Create a copy of form values and convert dates to UTC midnight
			const formData = { ...this.form1.value };
			if(formData?.propertyLeadProfileId?.propertyLeadProfileId != undefined && formData?.propertyLeadProfileId?.propertyLeadProfileId != null){
				formData.propertyLeadProfileId = formData?.propertyLeadProfileId?.propertyLeadProfileId;
			}
			this.convertDatesToUtcMidnight(formData);

			this.propertyProfileService.update(formData)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyProfile = res.data.propertyProfile;
						this.doUpdate.emit(this.propertyProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	updateOwnerProfileOfPropertyProfile() {
		try {
			this.formLoading = true;
			this.propertyProfile.ownerProfileVOList = this.form1.value.ownerProfileVOList;

			this.propertyProfileService.update(this.propertyProfile)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						//this.propertyProfile = res.data.propertyProfile;
						//this.doUpdate.emit(this.propertyProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.propertyProfileService.delete(this.propertyProfile.propertyProfileId)
				.subscribe(
					(res: any) => {
						console.log('propertyProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.propertyProfile);
					},
					(err: any) => {
						console.log('propertyProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formDeleteOfOwnerProfile(ownerProfile: any) {
		console.log("propertyProfile : ",JSON.stringify(ownerProfile));
				const propertyAndOwnerObj = {
					propertyProfileId: this.propertyProfile?.propertyProfileId,
					ownerProfileId: ownerProfile?.ownerProfileId,
				}
		try {
			this.propertyProfileService.deletePropertyAndOwnerProfileRelationship(propertyAndOwnerObj)
				.subscribe(
					(res: any) => {
						console.log('propertyProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.fetchPropertyProfileById();
					},
					(err: any) => {
						console.log('propertyProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	/*********
		* Edit Button
		*
		*/
		onOpenFormEdit(ownerProfile: OwnerProfile) {
			console.log("ownerProfile :"+JSON.stringify(ownerProfile));

			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				ownerProfile: ownerProfile,
				title: 'Edit Owner Profile'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(OwnerProfileComponent, dialogConfig);

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);


					// close the dialogBox
					dialogRef.close();
				});

			dialogRef.componentInstance.doDelete.subscribe(
				data => {
					console.log('Dialog output:', data);


					// close the dialogBox
					dialogRef.close();
				});
			}

			fetchOwnerProfileById(ownerProfile: OwnerProfile){
				try {
					this.ownerProfileService.findById(ownerProfile?.ownerProfileId)
						.subscribe(
							res => {
								 console.log('ownerLeadProfileService: ' + JSON.stringify(res));
								this.onOpenFormEdit(res.data.ownerProfile);
							},
							err => {
								console.log('Feature-Update FAIL: ' + JSON.stringify(err));
								this.alertService.error(err);
							},
							() => { });
				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.alertService.error(error);
				}
		}

	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyProfileId: [this.propertyProfileId],
			propertyName: ['', Validators.required],
			realEstateStatus: ['2', Validators.required],
			shortTermRentalId: [''],
			propertyCode: [],
			numFreeHousekeepings: [],
			numFreeRentalCarNights: [],
			fedTaxName: [],
			fedTaxBusName: [],
			fedTaxClass: [],
			fedTaxId: [],
			fedTaxAddress: [],
			taxPreparationSource: [],
			newReservationAlertEmail: [],
			newReservationAlertText: [],
			insCompanyName: [],
			insPolicyNum: [],
			insAgentName: [],
			insAgentEmail: [],
			insAgentPhone: [],
			bankName: [],
			bankRoutingNum: [],
			bankAccountNum: [],
			ambassadorUserId: [],
			taxDeptUsername: [],
			taxDeptPassword: [],
			taxDeptNotes: [],
			deepCleanPrepDays: [],
			ownerProfileVOList:  [],
			subjAdrCompanyName: [],
			subjAdrStreet: [],
			subjAdrStreet2: [],
			subjAdrCity: [],
			subjAdrState: [],
			subjAdrPostalCode: [],
			subjAdrCountry: [],
			subjAdrPhone: [],
			subjAdrFax: [],
			subjAdrUnit: [],
			subjAdrDevelopmentName: [],
			subjAdrDistrictName: [],
			subjAdrCounty: [],
			subjAdrRegion: [],
			subjAdrIsland: [],
			subjAdrCrossStreet: [],
			subjAdrLongitude: [],
			subjAdrLatitude: [],
			opsNotes: [],
			contractSignDate: [],
			firstCheckInDate: [],
			mgmtCommPct: [],
			subjAdrBuildingName: [],
			subjAdrComplexName: [],
			subjAdrStreetNumber: [],
			photographerDesc: [],
			trnsInEffectiveDate: [],
			trnsInReason: [],
			trnsInReasonDesc: [],
			trnsInNewMgrName: [],
			trnsInProcessDesc: [],
			trnsInHonoredBookingsDesc: [],
			trnsOutNoticeDate: [],
			trnsOutEffectiveDate: [],
			trnsOutReason: [],
			trnsOutReasonDesc: [],
			trnsOutNewMgrName: [],
			trnsOutProcessDesc: [],
			trnsOutHonoredBookingsDesc: [],
			taxPaidBy:[],
			showRezIncome: [],
			gig: [],
			purchasePriceAMT: [],
			purchaseDate: [],
			viewOnlineStmt:[],
			showPastReservationIncome:[],
			showPastOccupancyCalander:[],
			showMaintenanceTab:[],
			propertyLeadProfileId: [],

			estGrossRev: [],
			initialTermLengthMonths: [],
			subsequentTermLengthMonths: [],
			mgmtFeePCT: [],
			freeDepartureCleanNUM: [],
			freeCarDaysNUM: [],
			signCreditAMT: [],
			remodelCreditAMT: [],
			upgradeCredit: [],
			mgmtFeeCreditAMT: [],
			otherCreditAMT: [],
			termsSummaryDesc: [],
			maxMaintenanceFeeDiscretionAMT: [],
			referralFeeAMT: [],
			revenuePlan: [],
			propertyCondition: [],
			propertyScore: [],
			propertyScoreDesc: [],
			stmtProcDesc: [],
			bookingFee: [],
			maintServiceFreq: []
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.propertyProfile.propertyProfileDate = moment(this.propertyProfile.propertyProfileDate).toDate();
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.propertySummaryForShortData()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;

							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	fetchOwnerProfiles(){
			try {
				this.ownerProfileService.findOwnerProfileDropDown()
					.subscribe(
						res => {
							 console.log('findAllOwnerProfile: ' + JSON.stringify(res));
							this.ownerProfilesList = res.data.ownerProfiles;
							//set custom option label
							this.ownerProfilesList.forEach((ownerProfile, i) => {
								//set custom option label
								this.ownerProfilesList[i] = this.setPropertyLeadDisplayLabel(ownerProfile);
							});
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	formAddOwnerProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Owner Profile",
			isDisplayPropertyProfile : false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			OwnerProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);
			this.ownerProfilesList = [];
			this.fetchOwnerProfiles();


			if(this.propertyProfile){
				data.ownerProfileGuests = [];
				this.propertyProfile?.ownerProfileVOList.unshift(data);

				// no idea what this is but it is required to update the array
				this.propertyProfile.ownerProfileVOList = [...this.propertyProfile?.ownerProfileVOList];
				this.form1.patchValue({
						 ownerProfileVOList : this.propertyProfile?.ownerProfileVOList
					 });

			 }
		 	else{
				console.log("DATA :: "+data);
				data.ownerProfileGuests = [];
				this.ownerProfileObj.push(data);
				console.log("ownerProfileObj :: "+JSON.stringify(this.ownerProfileObj));
				 this.form1.patchValue({
				 	ownerProfileVOList : this.ownerProfileObj
				 });
			 }

			// close the dialogBox
			dialogRef.close();
		});
	}

	fetchPropertyProfileById(){
		try {
			this.propertyProfileService.findById(this.propertyProfile?.propertyProfileId)
				.subscribe(
					res => {
						 console.log('ownerLeadProfileService: ' + JSON.stringify(res));
						 this.propertyProfile.ownerProfileVOList = res.data.propertyProfile?.ownerProfileVOList;
						 this.form1.patchValue({
							ownerProfileVOList: ""
						 });
						 this.form1.patchValue({
							ownerProfileVOList: res.data.propertyProfile?.ownerProfileVOList
						 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

setPropertyLeadDisplayLabel(ownerProfile: any) {
	ownerProfile.displayLabel = "";
	if (ownerProfile.firstName != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + ownerProfile.firstName;
	}
	if (ownerProfile.lastName != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.lastName;
	}
	if (ownerProfile.emailAddress != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.emailAddress;
	}
	if (ownerProfile.mobilePhone != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.mobilePhone;
	}
	if (ownerProfile.mailAdrStreet != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.mailAdrStreet;
	}
	if (ownerProfile.mailAdrCity != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.mailAdrCity;
	}
	if (ownerProfile.mailAdrState != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.mailAdrState;
	}
	if (ownerProfile.mailAdrPostalCode != null) {
		ownerProfile.displayLabel = ownerProfile.displayLabel + " " + ownerProfile.mailAdrPostalCode;
	}
	return ownerProfile;
}

	// update owner portal access
	updateShowResIncomeFlag() {
		console.log('propertyProfile: ' + JSON.stringify(this.form1.value));
			try {
				// stop here if form is invalid
				this.form1.markAllAsTouched();
				if (this.form1.invalid) {
					return;
				}
				this.formLoading = true;

				const formData = { ...this.form1.value };
				if (formData?.propertyLeadProfileId?.propertyLeadProfileId != undefined && formData?.propertyLeadProfileId?.propertyLeadProfileId != null) {
					formData.propertyLeadProfileId = formData.propertyLeadProfileId.propertyLeadProfileId;
				}
				this.propertyProfileService.updateShowResIncomeFlag(formData)
					.subscribe(
						(res: any) => {
							this.formLoading = false;
							console.log('owner-update SUCCESS: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							this.propertyProfile = res.data?.propertyProfile;
							this.doUpdateShowResIncomeFlag.emit(this.propertyProfile);
						},
						(err: any) => {
							// Do NOT reset formLoading on error — a 504 means the backend may
							// have already saved the update. Keep button disabled to block re-submit.
							console.log('owner-update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.formLoading = false; });
			} catch (error) {
				this.formLoading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

		// search name of location
		changeNameFilter(name: string) {
			this.propertyLeadProfileService.search(name).then(value => {
				console.log(value);
				this.filteredNames = value.search.map((item: any) => {
					return {
						propertyLeadProfileId: item?.propertyLeadProfileId,
						firstName: item?.firstName,
						lastName: item?.lastName,
						subjAdrDevelopmentName: item?.subjAdrDevelopmentName,
						subjAdrStreet: item?.subjAdrStreet,
						summary: item?.subjAdrStreet+" "+item?.subjAdrDevelopmentName+" "+item?.firstName+" "+item?.lastName+" "+item?.propertyLeadProfileId
						// subjAdrUnit: item.subjAdrUnit,
						// subjAdrCity: item.subjAdrCity,
						// subjAdrState: item.subjAdrState
					}
				});
				console.log(this.filteredNames)
			})
		}

	findPropertyProfileById() {
		this.propertyProfileService.findById(this.propertyProfileId)
			.subscribe(
				(res: any) => {
					// Resolve the Promise with the picture file name
					this.propertyProfile = res?.data?.propertyProfile;
					if (this.propertyProfile) {
						//set custom option label
						this.propertyProfile.ownerProfileVOList.forEach((ownerProfile, i) => {
							//set custom option label
							this.propertyProfile.ownerProfileVOList[i] = this.setPropertyLeadDisplayLabel(ownerProfile);
						});
						this.propertyProfileId = this.propertyProfile.propertyProfileId;
						if (this.propertyProfile.showRezIncome != "true") {
							this.propertyProfile.showRezIncome = false;
						} else {
							this.propertyProfile.showRezIncome = true;
						}
						if (this.propertyProfile.trnsInEffectiveDate != undefined && this.propertyProfile.trnsInEffectiveDate != null) {
							this.propertyProfile.trnsInEffectiveDate = moment.utc(this.propertyProfile.trnsInEffectiveDate).toDate();
						}
						if (this.propertyProfile.trnsOutEffectiveDate != undefined && this.propertyProfile.trnsOutEffectiveDate != null) {
							this.propertyProfile.trnsOutEffectiveDate = moment.utc(this.propertyProfile.trnsOutEffectiveDate).toDate();
						}
						if (this.propertyProfile.trnsOutNoticeDate != undefined && this.propertyProfile.trnsOutNoticeDate != null) {
							this.propertyProfile.trnsOutNoticeDate = moment.utc(this.propertyProfile.trnsOutNoticeDate).toDate();
						}
						if (this.propertyProfile.contractSignDate != undefined && this.propertyProfile.contractSignDate != null) {
							this.propertyProfile.contractSignDate = moment.utc(this.propertyProfile.contractSignDate).toDate();
						}
						if (this.propertyProfile.firstCheckInDate != undefined && this.propertyProfile.firstCheckInDate != null) {
							this.propertyProfile.firstCheckInDate = moment.utc(this.propertyProfile.firstCheckInDate).toDate();
						}
						if (this.propertyProfile.purchaseDate != undefined && this.propertyProfile.purchaseDate != null) {
							this.propertyProfile.purchaseDate = moment.utc(this.propertyProfile.purchaseDate).toDate();
						}
						this.fixDates();
						if (this.propertyProfile.propertyLeadProfileId) {
							try {
								//making this synchronous so that locationId is not populated with null value
								this.findPropertyLeadProfileById();
							} catch (error) {
								console.log(error);
							}
						} else {
							this.form1.patchValue(this.propertyProfile);
							this.cdr.detectChanges();
						}
					}
				},
				(err: any) => {
					console.log('quote-add FAIL: ' + JSON.stringify(err));
					// Reject the Promise if there's an error
				},
				() => {
					this.formLoading = false;
				}
			);
	}

	findPropertyLeadProfileById() {
		this.propertyLeadProfileService.findById(this.propertyProfile.propertyLeadProfileId)
			.subscribe(
				(res: any) => {
					// Resolve the Promise with the picture file name
					this.propertyLeadProfile = res?.data?.propertyLeadProfile;
					if (this.propertyLeadProfile) {
						const locationObj = {
							propertyLeadProfileId: res.data.propertyLeadProfile?.propertyLeadProfileId,
							firstName: res.data.propertyLeadProfile?.firstName,
							lastName: res.data.propertyLeadProfile?.lastName,
							subjAdrDevelopmentName: res.data.propertyLeadProfile?.subjAdrDevelopmentName,
							subjAdrStreet: res.data.propertyLeadProfile?.subjAdrStreet,
							summary: res.data.propertyLeadProfile?.subjAdrStreet + " " + res.data.propertyLeadProfile?.subjAdrDevelopmentName + " " + res.data.propertyLeadProfile?.firstName + " " + res.data.propertyLeadProfile?.lastName + " " + res.data.propertyLeadProfile?.propertyLeadProfileId
						};

						this.filteredNames = [locationObj];
						this.propertyProfile.propertyLeadProfileId = locationObj;

						this.form1.patchValue({
							propertyLeadProfileId: locationObj
						});
						this.formLoading = false;
						this.form1.patchValue(this.propertyProfile);
						this.cdr.detectChanges();
					}
				},
				(err: any) => {
					console.log('quote-add FAIL: ' + JSON.stringify(err));
					// Reject the Promise if there's an error
				},
				() => {
					this.formLoading = false;
				}
			);
	}

	closePopUpOfQuote() {
		this.doUpdate.emit("close");
	}

	convertDatesToUtcMidnight(formData: any) {
		const dateFields = [
			'trnsInEffectiveDate',
			'trnsOutEffectiveDate',
			'trnsOutNoticeDate',
			'contractSignDate',
			'firstCheckInDate',
			'purchaseDate'
		];

		dateFields.forEach(field => {
			if (formData[field] != undefined && formData[field] != null) {
				formData[field] = this.toUtcMidnightIso(formData[field]);
			}
		});
	}

	toUtcMidnightIso(date: any): string | null {
		if (!date) return null;
		const d = new Date(date);
		d.setHours(0, 0, 0, 0);
		const utc = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
		return utc.toISOString();
	}
}
